<template>
	<div class="px-8 mb-8 sm:mb-0 mx-auto sm:mx-0">
        <input @keyup.enter.prevent="setSearch()" @blur="setSearch()" v-model="term" type="search" class="search rounded-3xl bg-lightgray px-8 py-3 text-sm text-primary" placeholder="Trouver un produit">
    </div>
</template>

<script>
	// import store from '../store/index'
	import router from '@/router'
    import store from '@/store/index'
	export default {
		data(){
			return {
				term: ""
			}
		},
		methods:{
			setSearch() {
                if(this.term){
                    console.log('search term')
                    router.push('/search/' + this.term )
                } else{
                  store.dispatch('deleteSelectedCategoris')
                  store.dispatch('deleteQueryParams')
                  store.dispatch('fetchProducts')
                  router.push({ path: '/' })
                }
			}
		},
		async created(){
      if(this.$route.params.term != 'no-results') {
        this.term = this.$route.params.term
      }
		}
	}
</script>
<style scoped>
	.search{
		width: 250px;
		text-align: center;
		background-image: url('../assets/search.svg');
		background-position: 90% center;
		background-repeat: no-repeat;
	}
  input[type=text]::-ms-clear {  display: none; width : 0; height: 0; }
  input[type=text]::-ms-reveal {  display: none; width : 0; height: 0; }
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }

</style>